if (process.env.NODE_ENV === "production") {
  module.exports = require("./cjs/react.production.min.js")
} else {
  module.exports = require("./cjs/react.development.js")
}



//////////////////
// WEBPACK FOOTER
// ./~/@lingui/react/index.js
// module id = QruM
// module chunks = 0